import React, {PropTypes} from 'react';
import Panel from 'shared/Panel.jsx';

const EntryCancel = ({
  readOnly,
  isCancelled,
  onEntryDetailCancelEntryClick,
  onEntryDetailReactivateEntryClick
}) => (
  <Panel
    className="panel-primary"
    title={isCancelled ? "Reactivate Entry" : "Cancel Entry"}
    style={{}}>
    <div className="row">
      <div className="col-sm-12">
        <div className="form-group">
          {isCancelled
            ?
              <div>
                <div>This entry has already been canceled</div>
                <div>If you would like to reactivate this entry, please click the button below</div>
              </div>
            : <div>Clicking the button below will cancel the entry, remove them from their squad, and allow you to enter in any amount you refunded them.</div>
          }
        </div>
      </div>
    </div>
    {isCancelled
      ? <div className="row">
          <div className="col-sm-12">
            <button
              type="submit"
              className="btn btn-default pull-right"
              style={{borderRadius: 10}}
              onClick={() => onEntryDetailReactivateEntryClick()}>
                {'Reactivate'}
            </button>
          </div>
        </div>
      : <div className="row">
          <div className="col-sm-12">
            <button
              type="submit"
              className="btn btn-default pull-right"
              style={{borderRadius: 10}}
              onClick={() => onEntryDetailCancelEntryClick()}
              disabled={readOnly}>
                {'Cancel'}
            </button>
          </div>
        </div>
    }
  </Panel>
);

EntryCancel.propTypes = {
  readOnly: PropTypes.bool,
  isCancelled: PropTypes.bool,
  onEntryDetailCancelEntryClick: PropTypes.func,
  onEntryDetailReactivateEntryClick: PropTypes.func
};

EntryCancel.defaultProps = {
  readOnly: false,
  isCancelled: false
};

export default EntryCancel;



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryCancel.jsx